import WhatIsSpiceExpertComponent from "../../components/become-expert/what-is-spice-expert";

const WhatIsSpiceExpertPage = () => <WhatIsSpiceExpertComponent />

export default WhatIsSpiceExpertPage;